import { INavigationItem } from '@konova/api-types';
import { createContext, FC, PropsWithChildren, useContext, useState } from 'react';

export type NavigationItemsContextType = {
  navigationItems: INavigationItem[];
  setNavigationItems: (items: INavigationItem[]) => void;
};

const NavigationItemsContext = createContext<NavigationItemsContextType>({
  navigationItems: [] as INavigationItem[],
  setNavigationItems: () => {
    throw new Error('setNavigationItems function must be overridden');
  },
});

export const useNavigationItemsContext = () => useContext(NavigationItemsContext);

export const NavigationItemsContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [navigationItems, setNavigationItems] = useState<INavigationItem[]>([]);

  return <NavigationItemsContext.Provider value={{
    navigationItems,
    setNavigationItems: (items: INavigationItem[]) => {
      setNavigationItems(items);
    }
  }}>
    {children}
  </NavigationItemsContext.Provider>;
};